import * as ActionTypes from './actionTypes';

export const setShowThanksModal = (show) => {
  return {
    'type': ActionTypes.SHOW_THANKS_MODAL,
    'payload': show,
  };
};
